import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { Api } from "../../../../services/api";

export function NewClassesDialog({ close, reload, classes }) {
    const [classeNome, setClasseNome] = useState('')
    const Footer = (
        <div className=" flex justify-content-center">
            <Button
                severity="success"
                label="Adicionar"
                icon="pi pi-plus"
                disabled={classeNome === ''}
                onClick={() => { adicionaClasse() }}
            />
        </div>
    )

    const adicionaClasse = async () => {
        let repetido = 0
        for (let i = 0; i < classes.length; i++) {
            if (classeNome.toUpperCase().trim() === classes[i].label.trim())
                repetido = repetido + 1
        }
        if (repetido === 0) {
            try {
                const { data } = await Api.post('cargacobrancas/adicionarClasse', { classe_nome: classeNome.trim() })
                toast.success('Classe adicionada com sucesso!')
                reload()
                close()
            } catch (error) {
                console.log(error)
                toast.error('Erro ao adicionar classe!')
            }
        } else
            toast.error('Já existe uma classe com este nome, por favor insira outro nome')
    }

    return (
        <Dialog
            visible
            header={`Adicionar Nova Classe`}
            onHide={close}
            style={{
                maxWidth: window.innerWidth > 760 ? '40vw' : '90vw',
                textAlign: 'center',
            }}
            footer={Footer}
        >
            <div className="grid">
                <div className="w-full md:w-7/12 mt-4 ml-2">
                    <h5>
                        Nome da Classe
                    </h5>
                    <InputText
                        value={classeNome}
                        onChange={(e) => setClasseNome(e.target.value)}
                        placeholder="Nome que identifique a classe ou campanha"
                    />
                </div>
                <div className="w-full md:w-1/3">
                    <i
                        className="pi pi-plus-circle p-mr-3 mt-4"
                        style={{ textAlign: "center", color: "green", fontSize: '10rem' }}
                    />
                </div>
            </div>
        </Dialog>
    );
}
